import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _setup.schoolWithGrade ? _c('dialog', {
    staticClass: "modal"
  }, [_c('h3', {
    staticClass: "modal__title"
  }, [_vm._v("送信先を選択")]), _c('div', {
    staticClass: "search",
    attrs: {
      "role": "search"
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "year"
    }
  }, [_vm._v("学年")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _setup.searchWord,
      expression: "searchWord"
    }],
    staticClass: "input",
    attrs: {
      "id": "year",
      "type": "text"
    },
    domProps: {
      "value": _setup.searchWord
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _setup.searchWord = $event.target.value;
      }
    }
  })]), _c('p', {
    staticClass: "show-schools"
  }, [_vm._v(" 候補：" + _vm._s(_setup.allSchoolList.length) + "校、 選択済み" + _vm._s(_vm.selectSchoolIdList.length) + "校 ")]), _c('form', {
    staticClass: "form",
    attrs: {
      "method": "dialog"
    }
  }, [_c('div', {
    staticClass: "form__top"
  }, [_c('input', {
    staticClass: "checkbox",
    attrs: {
      "id": "all",
      "name": "allSelect",
      "type": "checkbox"
    },
    domProps: {
      "checked": _setup.isAllSelect
    },
    on: {
      "change": _setup.handleAllSelect
    }
  }), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "all"
    }
  }, [_vm._v("すべて選択")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _setup.isShowChecked,
      expression: "isShowChecked"
    }],
    staticClass: "checkbox",
    attrs: {
      "id": "showChecked",
      "name": "showChecked",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_setup.isShowChecked) ? _vm._i(_setup.isShowChecked, null) > -1 : _setup.isShowChecked
    },
    on: {
      "change": function change($event) {
        var $$a = _setup.isShowChecked,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_setup.isShowChecked = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_setup.isShowChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _setup.isShowChecked = $$c;
        }
      }
    }
  }), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "showChecked"
    }
  }, [_vm._v("選択済みのみ表示")])]), _c('div', {
    staticClass: "form__schools"
  }, _vm._l(_setup.selectSchoolList, function (school) {
    return _c('ForumSelectDetailSchoolsSchool', {
      key: school.id,
      ref: "childRef",
      refInFor: true,
      attrs: {
        "school": school,
        "is-show-checked": _setup.isShowChecked,
        "search-word": _setup.searchWord
      },
      model: {
        value: _setup.tempSelectIdList,
        callback: function callback($$v) {
          _setup.tempSelectIdList = $$v;
        },
        expression: "tempSelectIdList"
      }
    });
  }), 1), _c('div', {
    staticClass: "form__bottom"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _setup.emit('toggleIsShowModal', false);
      }
    }
  }, [_vm._v(" キャンセル ")]), _c('button', {
    staticClass: "next",
    attrs: {
      "type": "button",
      "disabled": !_setup.tempSelectIdList.length
    },
    on: {
      "click": _setup.handleClickNext
    }
  }, [_vm._v(" 決定 ")])])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };